var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-plus-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.0001 12.9167H6.25009C5.08711 12.9167 4.50563 12.9167 4.03246 13.0602C2.96713 13.3834 2.13345 14.217 1.81028 15.2824C1.66675 15.7555 1.66675 16.337 1.66675 17.5M15.8334 17.5V12.5M13.3334 15H18.3334M12.0834 6.25C12.0834 8.32107 10.4045 10 8.33342 10C6.26235 10 4.58341 8.32107 4.58341 6.25C4.58341 4.17893 6.26235 2.5 8.33342 2.5C10.4045 2.5 12.0834 4.17893 12.0834 6.25Z",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserplus);
export default __webpack_public_path__ + "static/media/userplus.5310950e0b32d18e64051121a398f4b7.svg";
export { ForwardRef as ReactComponent };